// Where someone lands when they enter the app without a destination of their
// own: after logging in, and on /ui/v2/ for a returning session. One rule for
// everybody, Stramigo staff included: more than one place to go means choosing
// first.

export const ORGANISATION_TYPE_PARTNER = 'partner';

/**
 * The memberships that are a real choice. A membership left behind by the
 * admin "Open" button is not: staff reach those organisations through the
 * admin environment.
 *
 * @param {object|null} user store.state.user
 * @returns {object[]}
 */
export const getChooserMemberships = (user) => (
  (user?.memberships || []).filter((membership) => !membership.is_staff_access)
);

/**
 * The user's own membership of a partner, if any. A partner membership is
 * always direct: a partner is never the brand of another partner.
 *
 * @param {object|null} user store.state.user
 * @returns {object|null}
 */
export const getPartnerMembership = (user) => (
  getChooserMemberships(user).find(
    (membership) => membership.organisation?.type === ORGANISATION_TYPE_PARTNER,
  ) || null
);

export const isPartnerOrganisation = (organisation) => (
  organisation?.type === ORGANISATION_TYPE_PARTNER
);

/**
 * @param {object|null} user store.state.user
 * @returns {object|null} a route location, or null when the user has no place
 *   in this app (a reviewer).
 */
export const getLandingRoute = (user) => {
  // A partner's own screen is the chooser: its brands, plus anything else the
  // user can go to.
  if (getPartnerMembership(user)) {
    return { name: 'partner-home' };
  }

  const memberships = getChooserMemberships(user);
  const choices = memberships.length + (user?.sust ? 1 : 0);
  if (choices > 1) {
    return { name: 'organisation-chooser' };
  }
  if (memberships.length === 1) {
    return { name: 'organisation-home' };
  }
  if (user?.sust) {
    return { name: 'admin-home' };
  }
  // An unverified primary member has no verified memberships yet but does have
  // an organisation to finish registering.
  if (user?.org) {
    return { name: 'organisation-home' };
  }
  return null;
};
